import { memo, useCallback, useMemo } from 'react';
import MoreOptionsDropdown from 'domains/core/components/MoreOptionsDropdown';
import { AccessCentreRole } from 'domains/accessCentre/types';

export type RolesTableOptionsCellProps = {
    role: AccessCentreRole;
};

/**
 * Memoized cell that renders the more options dropdown for a role row (View, Edit, Duplicate, Delete).
 */
const RolesTableOptionsCell = ({ role }: RolesTableOptionsCellProps) => {
    const handleView = useCallback(() => {
        // TODO: open View role flow
    }, []);

    const handleEdit = useCallback(() => {
        // TODO: open Edit role flow
    }, []);

    const handleDuplicate = useCallback(() => {
        // TODO: open Duplicate role flow
    }, []);

    const handleDelete = useCallback(() => {
        // TODO: open Delete role flow
    }, []);

    const menuItems = useMemo(
        () => [
            { name: 'View', onClick: handleView, testId: `access-center-role-view-${role.id}` },
            { name: 'Edit', onClick: handleEdit, testId: `access-center-role-edit-${role.id}` },
            { name: 'Duplicate', onClick: handleDuplicate, testId: `access-center-role-duplicate-${role.id}` },
            { name: 'Delete', onClick: handleDelete, testId: `access-center-role-delete-${role.id}` },
        ],
        [handleView, handleEdit, handleDuplicate, handleDelete, role.id]
    );

    return <MoreOptionsDropdown buttonTestId={`access-center-role-options-${role.id}`} menuItems={menuItems} />;
};

export default memo(RolesTableOptionsCell);
